<template>
    <div>
        <swb-query-sort-area v-if="showQuery" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="table-layout">
            <el-table :data="servcList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : servcId != null && servcId == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="服务名称" align="left">
                    <template slot-scope="rows">
                        <span>{{rows.row.title}}</span>
                        <div v-if="rows.row.merchantType != servicerType" class="table-tips"></div>
                    </template>
                </el-table-column>
                <!--<el-table-column prop="name" label="服务标题" align="left"></el-table-column>-->
                <el-table-column label="服务类型" align="left" width="120" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{servcTypeMap[rows.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="catName" label="服务分类" align="left"></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout" v-if="totalCount > 10">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    //
    import servcApi from '../../api/servc'
    import servcCategApi from '../../api/servcCateg'
    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "服务名称",
                "code": "title",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Select",
                "label": "服务分类",
                "code": "catId",
                "valueType": 'Integer',
                "basic": true,
                "dataList": [],
            },

        ],
        "sortFields": []
    };
    export default{
        name: 'swb-servc-proprietary-dist-for-selected',
        desc: '自营和授权服务选择',
        props: {
            goodsCatId: {
                type: Number,
                default: null
            },
            engineerServcIds: {     // 过滤的服务ids - 【工程师能力服务ids】
                type: Array,
                default: function () {
                    return [];
                }
            },
            type: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                servcList: [],
                selectServc: null,
                servcId: null,
                servicerType: null,
                name: null,
                servcTypeMap: {},
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                showQuery: true,
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.servcTypeMap = getEnumMap('servcType', 'value2text');
            this.servicerType = getEnumInfoWith('merchantType', 'name', 'Servicer').value;
            //
            this.getMerchtFusedServcCat();
            this.getServcs();
        },
        methods: {
            getMerchtFusedServcCat: function () {
                let self = this;

                self.showQuery = false;
                servcCategApi.getMerchtFusedServcCatListByMerchantId({}, function (result) {
                    if(result.type == "info") {
                        let rows = result.data;
                        let queryConfig = searchConfigData || {};
                        let queryConfigMap = queryConfig.queryFields.toMap("code");
                        let catList = [];
                        if(rows != null && rows.length > 0) {
                            rows.forEach(function (item) {
                                let cat = {};
                                cat.value = item.catId;
                                cat.label = item.catName;
                                catList.push(cat);
                            });
                        }
                        let catListItem = queryConfigMap["catId"];
                        catListItem.dataList = [];
                        catListItem.dataList = Utils.merge([], catList);
                        self.queryConfig = Utils.merge({}, queryConfig);
                        self.showQuery = true;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.queryModel = queryModel;
                //
                this.getServcs();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getServcs();
            },
            //
            getServcs: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                if(!Utils.isNoB(self.name)) {
                    filterItems.name = self.name;
                }
                if(!Utils.isNoB(self.goodsCatId)) {
                    filterItems.goodsCatId = self.goodsCatId;
                }
                if(!Utils.isNoB(self.type)) {
                    filterItems.type = self.type;
                }
                let engineerServcIds = self.engineerServcIds;
                if(engineerServcIds != null && engineerServcIds.length > 0) {
                    filterItems.engineerServcIds = engineerServcIds;
                }
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                servcApi.getServcListByGoodsCatId(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.servcList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选中服务
            handleCurrentChange: function (val) {
                this.servcId = val.id;
                this.selectServc = Utils.merge({}, val);
            },
            //
            getDlgResult: function () {
                let self = this;
                let servcId = self.servcId;
                let result = {};
                if(!Utils.isNoB(servcId)) {
                    result.type = 'info';
                    result.data = this.selectServc;
                } else {
                    result.type = 'warn';
                    MsgBox.warning('请选择服务');
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/servc/ServcProprietaryAnddistForSelected.vue